// This file is auto-generated by @hey-api/openapi-ts
import { infiniteQueryOptions, queryOptions, } from "@tanstack/react-query";
import { client } from "../client.gen.js";
import { activateAvailabilityAlert, appIngestionLogin, appIngestionRefresh, createCommissioningEvent, createPlant, deactivateAvailabilityAlert, getAppIngestionPlantConfiguration, getAvailabilityAlert, getCompanies, getDocumentVersionDownloadUrl, getFeatureFlags, getHealth, getHsuLogDetail, getHsuLogs, getHsusTelemetry, getHsuTelemetryHardware, getHsuTelemetryIrradiance, getHsuTelemetrySnow, getHsuTelemetryWind, getMe, getNcuLogDetail, getNcuLogs, getPendingAnnouncements, getPlantActiveAlarms, getPlantAlarmEpisodes, getPlantAvailabilityHistory, getPlantAvailabilitySeries, getPlantAvailabilitySummary, getPlantById, getPlantCommunicationGaps, getPlantConfiguration, getPlantConfigurationDefaults, getPlantConfigurationDraft, getPlantConfigurationUserKeys, getPlantConfigurationVersion, getPlantDeclaredHsus, getPlantDivergences, getPlantHsuAlarms, getPlantHsuCommissioning, getPlantHsuDetails, getPlantHsus, getPlantHsusCurrent, getPlantIncidencesHistory, getPlantNcuAlarms, getPlantNcuDetails, getPlantNcus, getPlantNcusDeclared, getPlantPanHsuCommissioning, getPlantPanTcuCommissioning, getPlantRealSkyPerformance, getPlantRealSkySummary, getPlants, getPlantsAvailability, getPlantsKpis, getPlantTcuCommissioning, getPlantTcuDayAlarms, getPlantTcuDetails, getPlantTcus, getPlantTrackers, getPlantWeather, getTcuLogDetail, getTcuLogs, getTcuTelemetryAngles, getTcuTelemetryBattery1, getTcuTelemetryBattery2, getTcuTelemetryMotor, getTcuTelemetryPowerSupply, listAppIngestionPlants, listDocuments, listPlantConfigurations, login, markAnnouncementSeen, publishPlantConfiguration, savePlantConfigurationDraft, searchTcusTelemetry, updatePlant, } from "../sdk.gen.js";
const createQueryKey = (id, options, infinite, tags) => {
    const params = {
        _id: id,
        baseUrl: options?.baseUrl || (options?.client ?? client).getConfig().baseUrl,
    };
    if (infinite) {
        params._infinite = infinite;
    }
    if (tags) {
        params.tags = tags;
    }
    if (options?.body) {
        params.body = options.body;
    }
    if (options?.headers) {
        params.headers = options.headers;
    }
    if (options?.path) {
        params.path = options.path;
    }
    if (options?.query) {
        params.query = options.query;
    }
    return [params];
};
export const getHealthQueryKey = (options) => createQueryKey("getHealth", options);
/**
 * Estado del servicio
 *
 * Verifica el estado del servicio de Sunner Cloud.
 */
export const getHealthOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getHealth({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
        });
        return data;
    },
    queryKey: getHealthQueryKey(options),
});
export const getFeatureFlagsQueryKey = (options) => createQueryKey("getFeatureFlags", options);
/**
 * Obtener feature flags de frontend
 *
 * Devuelve todas las feature flags disponibles de frontend
 */
export const getFeatureFlagsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getFeatureFlags({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
        });
        return data;
    },
    queryKey: getFeatureFlagsQueryKey(options),
});
/**
 * Iniciar sesión de usuario
 *
 * Autentica a un usuario mediante email y contraseña y devuelve un token de acceso.
 */
export const loginMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await login({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const getMeQueryKey = (options) => createQueryKey("getMe", options);
/**
 * Obtener información del usuario autenticado
 *
 * Devuelve la información del usuario autenticado incluyendo sus permisos.
 */
export const getMeOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMe({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
        });
        return data;
    },
    queryKey: getMeQueryKey(options),
});
export const getCompaniesQueryKey = (options) => createQueryKey("getCompanies", options);
/**
 * Compañías
 *
 * Devuelve las compañías que pueden ser dueñas de una planta, para que el
 * formulario de alta las ofrezca. Solo responde a usuarios del operador: es
 * la única compañía que puede crear plantas para terceros, y la lista incluye
 * los nombres del resto de clientes.
 *
 */
export const getCompaniesOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getCompanies({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
        });
        return data;
    },
    queryKey: getCompaniesQueryKey(options),
});
export const getPlantsQueryKey = (options) => createQueryKey("getPlants", options);
/**
 * Plantas
 *
 * Obtención de un listado de plantas.
 */
export const getPlantsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPlants({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
        });
        return data;
    },
    queryKey: getPlantsQueryKey(options),
});
/**
 * Crear una planta
 *
 * Crea una planta a partir de sus datos de identidad. El resto lo resuelve el
 * servidor: la compañía dueña (la del creador, salvo que el operador indique
 * otra), el broker MQTT (el marcado por defecto en la compañía dueña), el
 * namespace MQTT (alfanumérico de 8, único por broker) y la zona horaria
 * (derivada de la latitud y la longitud).
 *
 * La planta nace en estado `construction` y sin dispositivos, así que aparece
 * como sin configurar en el listado. No se guardan credenciales MQTT: la
 * conexión es anónima.
 *
 * Toda la compañía dueña ve la planta desde el primer momento, sin
 * asignaciones por usuario.
 *
 * Exige el permiso `plant:create` y la feature flag `enable_plant_creation`
 * activa.
 *
 */
export const createPlantMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await createPlant({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const getPlantsKpisQueryKey = (options) => createQueryKey("getPlantsKpis", options);
/**
 * KPIs de la flota
 *
 * Devuelve los KPIs agregados de la flota del usuario autenticado.
 */
export const getPlantsKpisOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPlantsKpis({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
        });
        return data;
    },
    queryKey: getPlantsKpisQueryKey(options),
});
export const getPlantsAvailabilityQueryKey = (options) => createQueryKey("getPlantsAvailability", options);
/**
 * Obtener la disponibilidad reciente de las plantas accesibles
 *
 * Devuelve la disponibilidad reciente de todas las plantas accesibles por el usuario autenticado. Las plantas sin registros se omiten silenciosamente.
 */
export const getPlantsAvailabilityOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPlantsAvailability({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
        });
        return data;
    },
    queryKey: getPlantsAvailabilityQueryKey(options),
});
export const getPlantByIdQueryKey = (options) => createQueryKey("getPlantById", options);
/**
 * Obtener una planta específica
 *
 * Obtiene los detalles de una planta específica por su ID.
 */
export const getPlantByIdOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPlantById({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
        });
        return data;
    },
    queryKey: getPlantByIdQueryKey(options),
});
/**
 * Actualizar los datos generales de una planta
 *
 * Corrige los datos generales de una planta: nombre, localidad, país,
 * coordenadas y tamaño. Solo cambian los campos enviados, con las mismas
 * reglas que el alta. Al cambiar la localidad o el país se recompone
 * `location`, y al cambiar las coordenadas, la zona horaria.
 *
 * La compañía dueña no se edita desde aquí: cambiarla es una transferencia
 * (ADR 0012).
 *
 * Solo pueden escribir la compañía dueña y el operador. Una compañía con
 * concesión de solo lectura recibe 404, igual que en el borrador de
 * configuración.
 *
 */
export const updatePlantMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await updatePlant({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const getPlantNcusQueryKey = (options) => createQueryKey("getPlantNcus", options);
/**
 * Listar NCUs de una planta
 *
 * Obtiene el listado de NCUs asociadas a una planta.
 */
export const getPlantNcusOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPlantNcus({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
        });
        return data;
    },
    queryKey: getPlantNcusQueryKey(options),
});
export const getPlantTcusQueryKey = (options) => createQueryKey("getPlantTcus", options);
/**
 * Listar TCUs de una planta
 *
 * Obtiene el listado de TCUs asociadas a una planta.
 */
export const getPlantTcusOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPlantTcus({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
        });
        return data;
    },
    queryKey: getPlantTcusQueryKey(options),
});
export const getPlantHsusQueryKey = (options) => createQueryKey("getPlantHsus", options);
/**
 * Listar HSUs de una planta
 *
 * Obtiene el listado de HSUs asociadas a una planta.
 */
export const getPlantHsusOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPlantHsus({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
        });
        return data;
    },
    queryKey: getPlantHsusQueryKey(options),
});
export const getPlantTrackersQueryKey = (options) => createQueryKey("getPlantTrackers", options);
/**
 * Listar el layout declarado de una planta
 *
 * Obtiene los trackers del inventario declarado de una planta, con su posición
 * para pintar el layout.
 *
 */
export const getPlantTrackersOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPlantTrackers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
        });
        return data;
    },
    queryKey: getPlantTrackersQueryKey(options),
});
export const getPlantConfigurationQueryKey = (options) => createQueryKey("getPlantConfiguration", options);
/**
 * Consultar la configuración vigente de una planta
 *
 * Devuelve la configuración vigente de la planta —sus TCU y sus HSU con
 * nombre, slave, PAN ID y coordenadas, sus valores de planta de TCU y HSU y
 * su backtracking— junto con el número de versión, el usuario que la fijó y
 * cuándo. `backtracking` llega a null cuando la versión no lo declara, y los
 * valores de planta que la versión no declara, también.
 *
 * Incluye los dispositivos descubiertos, los que entraron por haberse
 * comisionado sin estar declarados: forman parte de la configuración vigente
 * igual que los declarados.
 *
 * Cada lista viene ordenada por red y, dentro de cada red, por slave, para
 * que la misma configuración se lea siempre igual. Ordenar por nombre no
 * sirve: en campo los dispositivos se llaman con números sin rellenar, y un
 * orden de texto los deja como `1, 10, 11, 2, 20`.
 *
 * Solo devuelve la vigente. El borrador de la planta no se consulta por aquí:
 * es un estado intermedio del wizard y no tiene versión ni autor.
 *
 * Responde 404 siempre que no haya configuración que devolver, sin distinguir
 * el motivo: la planta no existe, no es de tu cuenta, o existe y todavía no
 * tiene ninguna versión publicada. Mientras el layout siga alimentándose de
 * las tablas declaradas, una planta configurada por la vía del fichero de
 * campo responde 404 aunque su layout se pinte.
 *
 */
export const getPlantConfigurationOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPlantConfiguration({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
        });
        return data;
    },
    queryKey: getPlantConfigurationQueryKey(options),
});
/**
 * Fijar la configuración de una planta
 *
 * Fija la configuración recibida como la vigente de la planta: le asigna
 * número de versión, deja la anterior como histórico (`superseded`) y
 * registra quién la fijó y cuándo. Consume el borrador de la planta, si lo
 * había.
 *
 * A diferencia del borrador, no admite campos a medias: el schema exige
 * nombre, PAN ID y coordenadas en todos los dispositivos, e identifica en el
 * 400 cuál de ellos falla.
 *
 * El slave no se recibe: lo asigna Sunner Cloud, en el rango de su tipo —TCU
 * `[1, 229]`, HSU `[230, 245]`— y sin repetirlo dentro de un mismo PAN ID de
 * la planta. Un dispositivo que ya tenía slave en la versión anterior lo
 * conserva: es su dirección real en la red, y reasignarlo lo descolgaría del
 * comisionado y de la telemetría.
 *
 * Los dispositivos descubiertos de la versión anterior —los que entraron por
 * haberse comisionado, no por declararlos— se conservan en la nueva aunque no
 * vengan en el cuerpo: publicar no borra del layout un dispositivo que está
 * físicamente puesto.
 *
 * El backtracking no se recibe aquí: la versión nueva copia el del borrador.
 * Sin borrador, o con un borrador que no lo declara, conserva el de la
 * versión anterior.
 *
 * `zigbee_encryption` tampoco se recibe aquí: la versión nueva copia el del
 * borrador.
 *
 * Los valores de planta de TCU y HSU (`tcu_defaults`, `hsu_defaults`) tampoco:
 * la versión nueva copia los del borrador, y sin borrador conserva los de la
 * versión anterior. Rechaza publicar (400) si alguna alarma de viento tiene la
 * velocidad de desactivación por encima de la de activación.
 *
 * Cada NCU declara el PAN ID de su gateway 1 y, si lo tiene, del gateway 2.
 * Rechaza publicar si algún PAN ID de un TCU o una HSU no lo atiende ninguna
 * NCU: una red huérfana deja de ser posible en el dato.
 *
 */
export const publishPlantConfigurationMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await publishPlantConfiguration({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const getPlantConfigurationDraftQueryKey = (options) => createQueryKey("getPlantConfigurationDraft", options);
/**
 * Leer el borrador de configuración de una planta
 *
 * Devuelve el borrador tal cual se guardó, con los campos a medias que
 * tuviera: la forma de escritura sirve de lectura. No valida que la
 * configuración esté completa.
 *
 * 404 cuando la planta no tiene borrador. No es un error: es que el wizard
 * se abre vacío.
 *
 * El slave no viaja aquí: se asigna al publicar la versión.
 *
 * El backtracking vuelve con los campos que se guardaron y el resto a null.
 * Si el borrador no lo declara, `backtracking` llega a null. Igual con los
 * valores de planta de `tcu_defaults` y `hsu_defaults`: los no guardados
 * llegan a null.
 *
 */
export const getPlantConfigurationDraftOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPlantConfigurationDraft({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
        });
        return data;
    },
    queryKey: getPlantConfigurationDraftQueryKey(options),
});
/**
 * Guardar el borrador de configuración de una planta
 *
 * Guarda lo que el wizard lleva escrito. Reemplaza el borrador anterior de la
 * planta en lugar de acumular un segundo, y no toca la configuración vigente:
 * hasta que se publica, el borrador no se ve en el layout ni en ningún
 * contador.
 *
 * Admite campos a medias —el usuario todavía está escribiendo—, así que no
 * valida que la configuración esté completa. Sí rechaza un PAN ID mal formado,
 * un valor del backtracking o de los valores de planta fuera de rango, una
 * alarma de viento con la velocidad de desactivación por encima de la de
 * activación o una posición de una TCU que sus límites mecánicos no alcanzan
 * (400), y dos dispositivos con el mismo nombre (409). Una TCU sin límites
 * mecánicos o sin una posición se valida con el valor por defecto.
 *
 * El backtracking y los valores de planta de TCU y HSU viajan aquí, no en el
 * cuerpo de publicar: al publicar, la versión nueva los copia del borrador.
 *
 * El slave no se recibe: se asigna al publicar la versión. En el borrador
 * queda sin asignar.
 *
 */
export const savePlantConfigurationDraftMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await savePlantConfigurationDraft({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const getPlantConfigurationDefaultsQueryKey = (options) => createQueryKey("getPlantConfigurationDefaults", options);
/**
 * Consultar los valores por defecto de la plantilla de configuración
 *
 * Devuelve los valores por defecto de la plantilla de configuración: los que
 * el wizard muestra en un campo que el usuario no ha tocado y los que rellena
 * al publicar.
 *
 * No dependen de la planta. Cuelgan de ella para pasar por el mismo control
 * de acceso que el resto de su configuración.
 *
 * No se declaran con `default:` en los esquemas de escritura: Fastify los
 * aplicaría al validar, y el borrador guardaría como declarados valores que
 * el usuario no ha tocado.
 *
 */
export const getPlantConfigurationDefaultsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPlantConfigurationDefaults({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
        });
        return data;
    },
    queryKey: getPlantConfigurationDefaultsQueryKey(options),
});
export const listPlantConfigurationsQueryKey = (options) => createQueryKey("listPlantConfigurations", options);
/**
 * Listar las configuraciones de una planta
 *
 * Devuelve de un vistazo qué configuraciones tiene la planta: la vigente, el
 * borrador si lo hay y el historial de versiones superadas, de más reciente a
 * más antigua. Solo metadatos: qué versión es, quién la fijó y cuándo. Los
 * dispositivos de cada versión se piden con
 * `GET /plants/{plant_id}/configurations/{version}`.
 *
 * Los tres campos vienen siempre. `current` y `draft` son `null` cuando la
 * planta no tiene vigente o borrador, y `superseded` es una lista vacía si
 * nunca ha reemplazado una versión. Una planta recién creada responde 200 con
 * todo vacío: no tener configuración no es un error.
 *
 * El borrador no tiene versión ni autor: solo la fecha del último guardado.
 *
 * Responde 404 solo cuando la planta no existe o no es de tu cuenta, sin
 * distinguir el motivo.
 *
 */
export const listPlantConfigurationsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listPlantConfigurations({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
        });
        return data;
    },
    queryKey: listPlantConfigurationsQueryKey(options),
});
export const getPlantConfigurationVersionQueryKey = (options) => createQueryKey("getPlantConfigurationVersion", options);
/**
 * Consultar una versión publicada de la configuración de una planta
 *
 * Devuelve una versión publicada de la configuración de la planta, sea la
 * vigente o una ya superada, con la misma forma que
 * `GET /plants/{plant_id}/configuration`: sus TCU, sus HSU y sus NCU junto
 * con el número de versión, el usuario que la fijó y cuándo.
 *
 * Una versión superada se devuelve tal y como quedó al reemplazarse. La
 * respuesta no dice si es la vigente: eso lo cuenta el listado de
 * `GET /plants/{plant_id}/configurations`.
 *
 * El borrador no se consulta por aquí: no tiene versión.
 *
 * Responde 404 siempre que no haya versión que devolver, sin distinguir el
 * motivo: la planta no existe, no es de tu cuenta, o no tiene esa versión.
 *
 */
export const getPlantConfigurationVersionOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPlantConfigurationVersion({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
        });
        return data;
    },
    queryKey: getPlantConfigurationVersionQueryKey(options),
});
export const getPlantConfigurationUserKeysQueryKey = (options) => createQueryKey("getPlantConfigurationUserKeys", options);
/**
 * Descargar las user keys de las NCU de una versión publicada
 *
 * Devuelve el fichero de texto plano con las user keys del cifrado Zigbee
 * que el instalador carga en las NCU de una versión publicada de la
 * configuración de la planta. Es texto para leerlo, no un CSV: Excel convierte
 * en número los valores hex que lo parecen.
 *
 * La primera línea es `User keys Zigbee — {nombre de la planta}`. Debajo, un
 * bloque por NCU separado por una línea en blanco: el nombre de la NCU y una
 * línea por gateway que tenga PAN, con dos espacios de sangría y tres entre
 * campos: `Gateway {1|2}   PAN {pan_id}   User key {user_key}`. El PAN ID va en
 * 16 hex en minúsculas y la user key en hex en mayúsculas. UTF-8 con saltos de
 * línea `\r\n`.
 *
 * La user key es de la planta y el PAN, no de la versión: dos versiones que
 * usan el mismo PAN dan la misma. La longitud no es fija: hoy son 8
 * caracteres hexadecimales y pasarán a 32.
 *
 * Exige permiso de escritura sobre la planta: una concesión, que solo da
 * lectura, no basta. Responde 404 sin distinguir el motivo: la planta no
 * existe, no es de tu cuenta, no puedes escribir en ella o no tiene esa
 * versión. La descarga se puede repetir.
 *
 */
export const getPlantConfigurationUserKeysOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPlantConfigurationUserKeys({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
        });
        return data;
    },
    queryKey: getPlantConfigurationUserKeysQueryKey(options),
});
/**
 * Iniciar sesión en el canal de la app
 *
 * Autentica una cuenta de empresa cliente en el canal de la app y devuelve
 * la sesión (access + refresh) junto con la marca de la cuenta. Distinto del
 * login web: solo acepta cuentas con permiso de ingesta.
 *
 */
export const appIngestionLoginMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await appIngestionLogin({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
/**
 * Renovar la sesión del canal de la app
 *
 * Rota el refresh token (invalida el anterior) y devuelve un par nuevo de
 * tokens con caducidad deslizante. No requiere volver a introducir
 * credenciales.
 *
 */
export const appIngestionRefreshMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await appIngestionRefresh({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const listAppIngestionPlantsQueryKey = (options) => createQueryKey("listAppIngestionPlants", options);
/**
 * Listar las plantas de la cuenta (app de campo)
 *
 * Devuelve las plantas asignadas a la empresa de la cuenta, con su estado,
 * para elegir planta al iniciar la puesta en marcha. Solo las suyas.
 *
 */
export const listAppIngestionPlantsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listAppIngestionPlants({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
        });
        return data;
    },
    queryKey: listAppIngestionPlantsQueryKey(options),
});
export const getAppIngestionPlantConfigurationQueryKey = (options) => createQueryKey("getAppIngestionPlantConfiguration", options);
/**
 * Descargar la configuración de una planta (app de campo)
 *
 * Devuelve, en una sola respuesta, la configuración vigente de la planta
 * pedida y el número de la versión publicada. Cada TCU y cada HSU viaja con
 * todas las columnas de su plantilla de referencia (versión 1.5): el dato de
 * Cloud donde lo hay y el valor por defecto en el resto. Es la misma tabla
 * de la que salen los CSV que exporta la web.
 *
 * Incluye los dispositivos descubiertos, los que entraron por haberse
 * comisionado sin estar declarados: forman parte de la configuración
 * vigente igual que los declarados. El borrador no se descarga nunca.
 *
 * Lleva también si la red Zigbee de la planta va cifrada
 * (zigbee_encryption) y la user key de cada PAN (user_keys). La app busca
 * la user key de cada dispositivo por el panId de su fila. Con
 * zigbee_encryption false, user_keys es {} aunque la planta tenga user keys
 * guardadas de una versión anterior.
 *
 * Distingue la planta sin configuración de la que no se puede descargar:
 * 204 si la planta es de la cuenta pero todavía no tiene ninguna versión
 * publicada, y 404 si no existe o no es de la cuenta del token.
 *
 */
export const getAppIngestionPlantConfigurationOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getAppIngestionPlantConfiguration({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
        });
        return data;
    },
    queryKey: getAppIngestionPlantConfigurationQueryKey(options),
});
/**
 * Registrar el comisionado de un dispositivo en campo (app de campo)
 *
 * La app envía este evento tras comisionar un dispositivo por Bluetooth. El
 * endpoint no está scopeado a una planta: la planta se determina a partir de
 * la coordenada del dispositivo, así que la petición no lleva `plant_id`. Si
 * la coordenada no resuelve ninguna planta, el evento se guarda sin ella,
 * atribuido a la cuenta. Si resuelve una planta de otra empresa, se rechaza
 * y no queda rastro en esa planta.
 *
 */
export const createCommissioningEventMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await createCommissioningEvent({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const getPlantNcusDeclaredQueryKey = (options) => createQueryKey("getPlantNcusDeclared", options);
/**
 * Listar las NCUs declaradas de una planta
 *
 * Obtiene las NCUs del inventario declarado de una planta
 * (`configuration_declared_ncu`), con su posición para pintar el layout.
 *
 */
export const getPlantNcusDeclaredOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPlantNcusDeclared({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
        });
        return data;
    },
    queryKey: getPlantNcusDeclaredQueryKey(options),
});
export const getPlantDeclaredHsusQueryKey = (options) => createQueryKey("getPlantDeclaredHsus", options);
/**
 * Listar el placement declarado de HSU de una planta
 *
 * Obtiene las HSUs del placement declarado de una planta, con su posición para
 * pintar el layout.
 *
 */
export const getPlantDeclaredHsusOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPlantDeclaredHsus({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
        });
        return data;
    },
    queryKey: getPlantDeclaredHsusQueryKey(options),
});
export const getPlantDivergencesQueryKey = (options) => createQueryKey("getPlantDivergences", options);
/**
 * Listar los dispositivos que emiten sin estar en el inventario declarado
 *
 * Cruza el inventario declarado de la configuración vigente
 * (`configuration_declared_ncu`, `configuration_declared_device`) con el catálogo
 * observado y devuelve los dispositivos que emiten sin estar declarados. Es el
 * único caso que no se puede identificar en el mapa, porque un dispositivo no
 * declarado no tiene posición asignada. El cruce es por nombre dentro de la planta
 * y no escribe nada.
 *
 */
export const getPlantDivergencesOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPlantDivergences({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
        });
        return data;
    },
    queryKey: getPlantDivergencesQueryKey(options),
});
export const getPlantAvailabilityHistoryQueryKey = (options) => createQueryKey("getPlantAvailabilityHistory", options);
/**
 * Obtener historial de disponibilidad de las últimas 24 horas
 */
export const getPlantAvailabilityHistoryOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPlantAvailabilityHistory({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
        });
        return data;
    },
    queryKey: getPlantAvailabilityHistoryQueryKey(options),
});
export const getPlantAvailabilitySummaryQueryKey = (options) => createQueryKey("getPlantAvailabilitySummary", options);
/**
 * Disponibilidad acumulada de la planta en una ventana, con desglose por causa
 *
 * Calcula la disponibilidad acumulada sobre los episodios de veredicto
 * (`tcu_availability_episode`) para una ventana que termina en el momento de la
 * consulta (salvo día cerrado). El porcentaje y el desglose por causa salen del
 * mismo cálculo, así que siempre cuadran: la suma de `availability_impact_pct`
 * de las causas es `100 - availability_pct`.
 *
 */
export const getPlantAvailabilitySummaryOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPlantAvailabilitySummary({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
        });
        return data;
    },
    queryKey: getPlantAvailabilitySummaryQueryKey(options),
});
export const getPlantAvailabilitySeriesQueryKey = (options) => createQueryKey("getPlantAvailabilitySeries", options);
/**
 * Disponibilidad de la planta hora a hora en un periodo resuelto por el servidor
 *
 * Devuelve un bucket por hora (anclado a la frontera horaria UTC) desde el
 * inicio del periodo hasta su fin (`period_end`), calculado al leer sobre los
 * episodios de veredicto (`tcu_availability_episode`). Las horas sin tiempo
 * monitorizado y las futuras llevan `availability: null`; la hora que contiene
 * el ahora se calcula con lo transcurrido y lleva `is_partial: true`.
 *
 */
export const getPlantAvailabilitySeriesOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPlantAvailabilitySeries({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
        });
        return data;
    },
    queryKey: getPlantAvailabilitySeriesQueryKey(options),
});
export const getPlantIncidencesHistoryQueryKey = (options) => createQueryKey("getPlantIncidencesHistory", options);
/**
 * Historial de incidencias de la planta
 *
 * Obtiene el resumen diario de incidencias de los 6 días locales previos al día en curso en la zona horaria de la planta, ordenados de más reciente a más antiguo.
 */
export const getPlantIncidencesHistoryOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPlantIncidencesHistory({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
        });
        return data;
    },
    queryKey: getPlantIncidencesHistoryQueryKey(options),
});
export const getPlantTcuDayAlarmsQueryKey = (options) => createQueryKey("getPlantTcuDayAlarms", options);
/**
 * Alarmas TCU por rango de fechas
 *
 * Obtiene las alarmas de los TCUs de la planta para un rango de fechas, agrupadas por tracker y TCU. Opcionalmente filtra por dispositivo.
 */
export const getPlantTcuDayAlarmsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPlantTcuDayAlarms({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
        });
        return data;
    },
    queryKey: getPlantTcuDayAlarmsQueryKey(options),
});
export const getPlantCommunicationGapsQueryKey = (options) => createQueryKey("getPlantCommunicationGaps", options);
/**
 * Histórico de cortes de comunicación
 *
 * Obtiene los cortes de comunicación (comm_gap) de los dispositivos de la planta que solapan con la ventana temporal indicada, ordenados por fecha de apertura descendente. Paginación keyset mediante cursor opaco.
 */
export const getPlantCommunicationGapsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPlantCommunicationGaps({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
        });
        return data;
    },
    queryKey: getPlantCommunicationGapsQueryKey(options),
});
const createInfiniteParams = (queryKey, page) => {
    const params = { ...queryKey[0] };
    if (page.body) {
        params.body = {
            ...queryKey[0].body,
            ...page.body,
        };
    }
    if (page.headers) {
        params.headers = {
            ...queryKey[0].headers,
            ...page.headers,
        };
    }
    if (page.path) {
        params.path = {
            ...queryKey[0].path,
            ...page.path,
        };
    }
    if (page.query) {
        params.query = {
            ...queryKey[0].query,
            ...page.query,
        };
    }
    return params;
};
export const getPlantCommunicationGapsInfiniteQueryKey = (options) => createQueryKey("getPlantCommunicationGaps", options, true);
/**
 * Histórico de cortes de comunicación
 *
 * Obtiene los cortes de comunicación (comm_gap) de los dispositivos de la planta que solapan con la ventana temporal indicada, ordenados por fecha de apertura descendente. Paginación keyset mediante cursor opaco.
 */
export const getPlantCommunicationGapsInfiniteOptions = (options) => {
    const opts = infiniteQueryOptions(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page = typeof pageParam === "object"
                ? pageParam
                : {
                    query: {
                        cursor: pageParam,
                    },
                };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getPlantCommunicationGaps({
                ...options,
                ...params,
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: getPlantCommunicationGapsInfiniteQueryKey(options),
    });
    return opts;
};
export const getPlantHsuAlarmsQueryKey = (options) => createQueryKey("getPlantHsuAlarms", options);
/**
 * Alarmas HSU por rango de fechas
 *
 * Obtiene las alarmas de los HSUs de la planta para un rango de fechas. Opcionalmente filtra por dispositivo.
 */
export const getPlantHsuAlarmsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPlantHsuAlarms({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
        });
        return data;
    },
    queryKey: getPlantHsuAlarmsQueryKey(options),
});
export const getPlantNcuAlarmsQueryKey = (options) => createQueryKey("getPlantNcuAlarms", options);
/**
 * Alarmas NCU por rango de fechas
 *
 * Obtiene las alarmas de las NCUs de la planta para un rango de fechas. Opcionalmente filtra por dispositivo.
 */
export const getPlantNcuAlarmsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPlantNcuAlarms({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
        });
        return data;
    },
    queryKey: getPlantNcuAlarmsQueryKey(options),
});
export const getPlantAlarmEpisodesQueryKey = (options) => createQueryKey("getPlantAlarmEpisodes", options);
/**
 * Histórico de episodios de alarma de un dispositivo
 *
 * Obtiene el histórico de episodios de alarma de un dispositivo desde la tabla alarm_episode, ordenado de más reciente a más antiguo. Consultable más allá de 7 días, con paginación keyset (cursor opaco) y ventana máxima de 92 días (el servidor la acota). A diferencia de getPlantCommunicationGaps (ventana de planta, from/to obligatorios, límite hasta 2000), este endpoint es por dispositivo: from/to son opcionales (por defecto, últimos 92 días) y el límite por página llega a 500.
 */
export const getPlantAlarmEpisodesOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPlantAlarmEpisodes({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
        });
        return data;
    },
    queryKey: getPlantAlarmEpisodesQueryKey(options),
});
export const getPlantAlarmEpisodesInfiniteQueryKey = (options) => createQueryKey("getPlantAlarmEpisodes", options, true);
/**
 * Histórico de episodios de alarma de un dispositivo
 *
 * Obtiene el histórico de episodios de alarma de un dispositivo desde la tabla alarm_episode, ordenado de más reciente a más antiguo. Consultable más allá de 7 días, con paginación keyset (cursor opaco) y ventana máxima de 92 días (el servidor la acota). A diferencia de getPlantCommunicationGaps (ventana de planta, from/to obligatorios, límite hasta 2000), este endpoint es por dispositivo: from/to son opcionales (por defecto, últimos 92 días) y el límite por página llega a 500.
 */
export const getPlantAlarmEpisodesInfiniteOptions = (options) => {
    const opts = infiniteQueryOptions(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page = typeof pageParam === "object"
                ? pageParam
                : {
                    query: {
                        cursor: pageParam,
                    },
                };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getPlantAlarmEpisodes({
                ...options,
                ...params,
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: getPlantAlarmEpisodesInfiniteQueryKey(options),
    });
    return opts;
};
export const getPlantActiveAlarmsQueryKey = (options) => createQueryKey("getPlantActiveAlarms", options);
/**
 * Alarmas activas de la planta (fuente única)
 *
 * Obtiene todas las alarmas actualmente activas de la planta desde una única lectura: los episodios de alarma abiertos (alarm_episode con ended_at null) unidos con los cortes de comunicación abiertos (comm_gap), presentando cada corte como una alarma con alarm_code 'communication'.
 */
export const getPlantActiveAlarmsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPlantActiveAlarms({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
        });
        return data;
    },
    queryKey: getPlantActiveAlarmsQueryKey(options),
});
export const getPlantNcuDetailsQueryKey = (options) => createQueryKey("getPlantNcuDetails", options);
/**
 * Obtener datos de una NCU específica.
 *
 * Devuelve los datos de detalle de una NCU en una planta.
 */
export const getPlantNcuDetailsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPlantNcuDetails({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
        });
        return data;
    },
    queryKey: getPlantNcuDetailsQueryKey(options),
});
export const getPlantTcuDetailsQueryKey = (options) => createQueryKey("getPlantTcuDetails", options);
/**
 * Obtener datos de detalle de un TCU específico.
 *
 * Devuelve los datos de detalle de un TCU en una planta.
 */
export const getPlantTcuDetailsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPlantTcuDetails({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
        });
        return data;
    },
    queryKey: getPlantTcuDetailsQueryKey(options),
});
export const getPlantHsuDetailsQueryKey = (options) => createQueryKey("getPlantHsuDetails", options);
/**
 * Obtener datos de detalle de una HSU específico.
 *
 * Devuelve los datos de detalle de una HSU en una planta.
 */
export const getPlantHsuDetailsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPlantHsuDetails({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
        });
        return data;
    },
    queryKey: getPlantHsuDetailsQueryKey(options),
});
export const getPlantTcuCommissioningQueryKey = (options) => createQueryKey("getPlantTcuCommissioning", options);
/**
 * Configuración avanzada (comisionado) de un TCU
 *
 * Devuelve la configuración avanzada con la que quedó comisionado un TCU:
 * identidad, NCU asociada, MAC Zigbee, firmwares y versiones, fechas, offset y
 * coordenadas. Responde 200 con `commissioning_state` aunque el dispositivo aún
 * no esté comisionado (campos de comisionado en null); 404 solo si el TCU no
 * existe en el inventario declarado.
 *
 */
export const getPlantTcuCommissioningOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPlantTcuCommissioning({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
        });
        return data;
    },
    queryKey: getPlantTcuCommissioningQueryKey(options),
});
export const getPlantHsuCommissioningQueryKey = (options) => createQueryKey("getPlantHsuCommissioning", options);
/**
 * Configuración avanzada (comisionado) de una HSU
 *
 * Devuelve la configuración avanzada con la que quedó comisionada una HSU:
 * identidad, NCU asociada, MAC Zigbee, firmwares y versiones, fechas y
 * coordenadas. Responde 200 con `commissioning_state` aunque el dispositivo aún
 * no esté comisionado (campos de comisionado en null); 404 solo si la HSU no
 * existe en el inventario declarado.
 *
 */
export const getPlantHsuCommissioningOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPlantHsuCommissioning({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
        });
        return data;
    },
    queryKey: getPlantHsuCommissioningQueryKey(options),
});
export const getPlantPanTcuCommissioningQueryKey = (options) => createQueryKey("getPlantPanTcuCommissioning", options);
/**
 * Configuración avanzada (comisionado) de un TCU declarado
 *
 * Igual que `/plants/{plant_id}/ncus/{ncu_name}/tcus/{tcu_name}/commissioning`,
 * pero identifica a el TCU por su identidad declarada (`pan_id`, `slave_id`), la
 * única que existe aunque ninguna NCU declarada reclame su red. La de NCU es la
 * identidad observada, para las pantallas que parten del dispositivo que emite.
 * Responde 200 con `commissioning_state` aunque aún no esté comisionado; 404 solo
 * si no existe en el inventario declarado.
 *
 */
export const getPlantPanTcuCommissioningOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPlantPanTcuCommissioning({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
        });
        return data;
    },
    queryKey: getPlantPanTcuCommissioningQueryKey(options),
});
export const getPlantPanHsuCommissioningQueryKey = (options) => createQueryKey("getPlantPanHsuCommissioning", options);
/**
 * Configuración avanzada (comisionado) de una HSU declarada
 *
 * Igual que `/plants/{plant_id}/ncus/{ncu_name}/hsus/{hsu_name}/commissioning`,
 * pero identifica a la HSU por su identidad declarada (`pan_id`, `slave_id`), la
 * única que existe aunque ninguna NCU declarada reclame su red. La de NCU es la
 * identidad observada, para las pantallas que parten del dispositivo que emite.
 * Responde 200 con `commissioning_state` aunque aún no esté comisionado; 404 solo
 * si no existe en el inventario declarado.
 *
 */
export const getPlantPanHsuCommissioningOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPlantPanHsuCommissioning({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
        });
        return data;
    },
    queryKey: getPlantPanHsuCommissioningQueryKey(options),
});
/**
 * Search TCU telemetry data with automatic resolution selection
 *
 * Endpoint unificado para búsqueda de telemetría TCU que selecciona automáticamente
 * la resolución óptima basada en la duración del rango temporal.
 *
 * El backend decide la fuente de datos y resolución:
 * - <2h: datos raw (~6-12 segundos de resolución)
 * - 2-24h: agregación por minuto (tcu_telemetry_full)
 * - >24h: agregación por 10 minutos (tcu_telemetry_10min)
 *
 * Formato de respuesta columnar optimizado:
 * - Timestamps compartidos entre todas las series
 * - Arrays densos de valores numéricos
 * - Epoch seconds en lugar de strings ISO 8601
 * - Reducción de ~90% en tamaño de payload vs formato tradicional
 *
 * Límites de rendimiento:
 * - Máximo ~1000-1500 puntos por serie
 * - Latencia típica: <3s para cualquier rango
 * - Memoria del backend: <100MB por query
 *
 * Beneficios vs endpoints anteriores:
 * - Un solo endpoint para todos los rangos temporales
 * - El frontend no necesita decidir raw vs aggregated
 * - Respuesta optimizada para renderizado de gráficos
 *
 */
export const searchTcusTelemetryMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await searchTcusTelemetry({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const getPlantWeatherQueryKey = (options) => createQueryKey("getPlantWeather", options);
/**
 * Obtener predicción meteorológica para una planta
 *
 * Obtiene la predicción meteorológica para una planta específica, incluyendo datos históricos
 * del día actual y pronóstico para los próximos días.
 *
 * **Nota**: Este es un endpoint stub que devuelve datos mock para desarrollo y testing.
 * En producción, se integrará con un servicio meteorológico real.
 *
 */
export const getPlantWeatherOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPlantWeather({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
        });
        return data;
    },
    queryKey: getPlantWeatherQueryKey(options),
});
export const getTcuTelemetryAnglesQueryKey = (options) => createQueryKey("getTcuTelemetryAngles", options);
/**
 * Obtener datos de ángulo y ángulo objetivo de seguimiento de un TCU (hoy vs ayer)
 *
 * Obtiene los datos de ángulos objetivo/reales de hoy/ayer para una TCU específica.
 */
export const getTcuTelemetryAnglesOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getTcuTelemetryAngles({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
        });
        return data;
    },
    queryKey: getTcuTelemetryAnglesQueryKey(options),
});
export const getTcuTelemetryBattery1QueryKey = (options) => createQueryKey("getTcuTelemetryBattery1", options);
/**
 * Obtener estado de carga y temperatura de la batería de una TCU (hoy vs ayer)
 *
 * Obtiene los datos de estado de carga y temperatura de batería de hoy/ayer para una TCU específica.
 */
export const getTcuTelemetryBattery1Options = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getTcuTelemetryBattery1({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
        });
        return data;
    },
    queryKey: getTcuTelemetryBattery1QueryKey(options),
});
export const getTcuTelemetryBattery2QueryKey = (options) => createQueryKey("getTcuTelemetryBattery2", options);
/**
 * Obtener estado de voltaje y corriente de la batería de una TCU (hoy vs ayer)
 *
 * Obtiene los datos de estado de voltaje y corriente de batería de hoy/ayer para una TCU específica.
 */
export const getTcuTelemetryBattery2Options = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getTcuTelemetryBattery2({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
        });
        return data;
    },
    queryKey: getTcuTelemetryBattery2QueryKey(options),
});
export const getTcuTelemetryMotorQueryKey = (options) => createQueryKey("getTcuTelemetryMotor", options);
/**
 * Obtener datos de corriente máxima y consumo del motor de una TCU (hoy vs ayer)
 *
 * Obtiene los datos de corriente máxima y consumo de hoy/ayer para el motor de una TCU específica.
 */
export const getTcuTelemetryMotorOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getTcuTelemetryMotor({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
        });
        return data;
    },
    queryKey: getTcuTelemetryMotorQueryKey(options),
});
export const getTcuTelemetryPowerSupplyQueryKey = (options) => createQueryKey("getTcuTelemetryPowerSupply", options);
/**
 * Obtener datos de corriente y voltaje de la fuente de alimentación de una TCU (hoy vs ayer)
 *
 * Obtiene los datos de corriente y voltaje de hoy/ayer para la fuente de alimentación de una TCU específica.
 */
export const getTcuTelemetryPowerSupplyOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getTcuTelemetryPowerSupply({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
        });
        return data;
    },
    queryKey: getTcuTelemetryPowerSupplyQueryKey(options),
});
export const getPlantHsusCurrentQueryKey = (options) => createQueryKey("getPlantHsusCurrent", options);
/**
 * Snapshot agregado de viento e irradiancia de los HSUs de una planta
 *
 * Devuelve la media, mínimo y máximo de viento e irradiancia calculados
 * a partir de la última lectura de cada HSU que haya reportado dentro
 * de los últimos 15 minutos. Si ninguna HSU ha reportado en ese rango,
 * los agregados son `null`.
 *
 */
export const getPlantHsusCurrentOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPlantHsusCurrent({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
        });
        return data;
    },
    queryKey: getPlantHsusCurrentQueryKey(options),
});
export const getHsusTelemetryQueryKey = (options) => createQueryKey("getHsusTelemetry", options);
/**
 * Obtener datos de telemetría de los HSUs de una planta
 *
 * Obtiene los datos históricos de telemetría para todos los HSUs de una planta específica.
 */
export const getHsusTelemetryOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getHsusTelemetry({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
        });
        return data;
    },
    queryKey: getHsusTelemetryQueryKey(options),
});
export const getHsuTelemetryWindQueryKey = (options) => createQueryKey("getHsuTelemetryWind", options);
/**
 * Obtener datos de velocidad y ángulo de viento de una HSU (hoy vs ayer)
 *
 * Obtiene los datos de velocidad/ángulo de viento de hoy/ayer para una HSU específica.
 */
export const getHsuTelemetryWindOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getHsuTelemetryWind({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
        });
        return data;
    },
    queryKey: getHsuTelemetryWindQueryKey(options),
});
export const getHsuTelemetrySnowQueryKey = (options) => createQueryKey("getHsuTelemetrySnow", options);
/**
 * Obtener datos de altura de nieve de una HSU (hoy vs ayer)
 *
 * Obtiene los datos históricos de altura de nieve de hoy/ayer para una HSU específica.
 */
export const getHsuTelemetrySnowOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getHsuTelemetrySnow({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
        });
        return data;
    },
    queryKey: getHsuTelemetrySnowQueryKey(options),
});
export const getHsuTelemetryHardwareQueryKey = (options) => createQueryKey("getHsuTelemetryHardware", options);
/**
 * Obtener voltajes de baterías y temperatura PCB de una HSU (hoy vs ayer)
 *
 * Obtiene los datos de voltajes de baterías (principal y respaldo) y temperatura del PCB de hoy/ayer para una HSU específica.
 */
export const getHsuTelemetryHardwareOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getHsuTelemetryHardware({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
        });
        return data;
    },
    queryKey: getHsuTelemetryHardwareQueryKey(options),
});
export const getHsuTelemetryIrradianceQueryKey = (options) => createQueryKey("getHsuTelemetryIrradiance", options);
/**
 * Obtener datos de irradiancia de una HSU/WFU (hoy vs ayer)
 *
 * Obtiene los datos de irradiancia (GHI, GTI, DNI) de hoy/ayer para una HSU/WFU específica.
 */
export const getHsuTelemetryIrradianceOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getHsuTelemetryIrradiance({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
        });
        return data;
    },
    queryKey: getHsuTelemetryIrradianceQueryKey(options),
});
export const getNcuLogsQueryKey = (options) => createQueryKey("getNcuLogs", options);
/**
 * Archivos de log de una NCU
 *
 * Obtiene el listado de archivos de log de una NCU específica.
 */
export const getNcuLogsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getNcuLogs({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
        });
        return data;
    },
    queryKey: getNcuLogsQueryKey(options),
});
export const getTcuLogsQueryKey = (options) => createQueryKey("getTcuLogs", options);
/**
 * Archivos de log de una TCU
 *
 * Obtiene el listado de archivos de log de una TCU específico.
 */
export const getTcuLogsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getTcuLogs({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
        });
        return data;
    },
    queryKey: getTcuLogsQueryKey(options),
});
export const getHsuLogsQueryKey = (options) => createQueryKey("getHsuLogs", options);
/**
 * Archivos de log de una HSU
 *
 * Obtiene el listado de archivos de log de una HSU específica.
 */
export const getHsuLogsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getHsuLogs({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
        });
        return data;
    },
    queryKey: getHsuLogsQueryKey(options),
});
export const getNcuLogDetailQueryKey = (options) => createQueryKey("getNcuLogDetail", options);
/**
 * Detalle de un archivo de log de una NCU
 *
 * Obtiene el contenido detallado de un archivo de log específico de una NCU.
 */
export const getNcuLogDetailOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getNcuLogDetail({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
        });
        return data;
    },
    queryKey: getNcuLogDetailQueryKey(options),
});
export const getTcuLogDetailQueryKey = (options) => createQueryKey("getTcuLogDetail", options);
/**
 * Detalle de un archivo de log de un TCU
 *
 * Obtiene el contenido detallado de un archivo de log específico de un TCU.
 */
export const getTcuLogDetailOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getTcuLogDetail({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
        });
        return data;
    },
    queryKey: getTcuLogDetailQueryKey(options),
});
export const getHsuLogDetailQueryKey = (options) => createQueryKey("getHsuLogDetail", options);
/**
 * Detalle de un archivo de log de un HSU
 *
 * Obtiene el contenido detallado de un archivo de log específico de un HSU.
 */
export const getHsuLogDetailOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getHsuLogDetail({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
        });
        return data;
    },
    queryKey: getHsuLogDetailQueryKey(options),
});
export const getPlantRealSkyPerformanceQueryKey = (options) => createQueryKey("getPlantRealSkyPerformance", options);
/**
 * RealSky Performance para un rango de tiempo
 */
export const getPlantRealSkyPerformanceOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPlantRealSkyPerformance({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
        });
        return data;
    },
    queryKey: getPlantRealSkyPerformanceQueryKey(options),
});
export const getPlantRealSkySummaryQueryKey = (options) => createQueryKey("getPlantRealSkySummary", options);
/**
 * Resumen Real Sky agregado sobre los últimos días cerrados
 *
 * Devuelve un resumen agregado de Real Sky sobre los últimos `days` días
 * cerrados (días completos ya transcurridos, sin incluir el día en curso) en
 * la zona horaria de la planta. El cálculo se realiza en tiempo de consulta
 * sobre los snapshots, sin tablas de agregados intermedias.
 *
 */
export const getPlantRealSkySummaryOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPlantRealSkySummary({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
        });
        return data;
    },
    queryKey: getPlantRealSkySummaryQueryKey(options),
});
/**
 * Desactivar el aviso de disponibilidad activo
 *
 * Desactiva el aviso de disponibilidad activo del usuario de la sesión.
 *
 * Exige la feature flag `availability_alerts_enabled` activa para el usuario.
 *
 */
export const deactivateAvailabilityAlertMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await deactivateAvailabilityAlert({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const getAvailabilityAlertQueryKey = (options) => createQueryKey("getAvailabilityAlert", options);
/**
 * Leer el aviso de disponibilidad activo del usuario
 *
 * Devuelve el aviso de disponibilidad activo del usuario de la sesión. Un
 * usuario tiene como mucho uno activo. Sin aviso activo, `alert` es `null`.
 *
 * Exige la feature flag `availability_alerts_enabled` activa para el usuario.
 *
 */
export const getAvailabilityAlertOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getAvailabilityAlert({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
        });
        return data;
    },
    queryKey: getAvailabilityAlertQueryKey(options),
});
/**
 * Activar un aviso de disponibilidad
 *
 * Crea el aviso de disponibilidad activo del usuario de la sesión. Un aviso no
 * se edita: para cambiarlo se desactiva y se activa otro.
 *
 * Exige la feature flag `availability_alerts_enabled` activa para el usuario.
 *
 */
export const activateAvailabilityAlertMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await activateAvailabilityAlert({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const listDocumentsQueryKey = (options) => createQueryKey("listDocuments", options);
/**
 * Listado de documentos técnicos disponibles
 */
export const listDocumentsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listDocuments({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
        });
        return data;
    },
    queryKey: listDocumentsQueryKey(options),
});
export const getDocumentVersionDownloadUrlQueryKey = (options) => createQueryKey("getDocumentVersionDownloadUrl", options);
/**
 * URL temporal de descarga para una versión de documento
 */
export const getDocumentVersionDownloadUrlOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getDocumentVersionDownloadUrl({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
        });
        return data;
    },
    queryKey: getDocumentVersionDownloadUrlQueryKey(options),
});
export const getPendingAnnouncementsQueryKey = (options) => createQueryKey("getPendingAnnouncements", options);
/**
 * Anuncios pendientes del usuario
 *
 * Devuelve los anuncios pendientes del usuario de la sesión, ordenados por
 * fecha de alta del anuncio. Un anuncio está pendiente si su flag está activa
 * para el usuario, la flag de la funcionalidad que anuncia no existe o está
 * activa para él, y no lo ha visto.
 *
 */
export const getPendingAnnouncementsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPendingAnnouncements({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
        });
        return data;
    },
    queryKey: getPendingAnnouncementsQueryKey(options),
});
/**
 * Marcar un anuncio como visto
 *
 * Marca el anuncio como visto para el usuario de la sesión. El primer cierre
 * gana: si ya estaba visto, responde igual y no cambia nada. No comprueba
 * flags.
 *
 */
export const markAnnouncementSeenMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await markAnnouncementSeen({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
//# sourceMappingURL=react-query.gen.js.map